import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const SchoolInformationLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'SchoolInformation' */ './components/SchoolInformation'
		)
);

export default (store) => {
	return {
		path: 'school-information',
		element: <AsyncLoading component={<SchoolInformationLazy />} />,
	};
};
